<template>
    <div class="mx-2 mx-md-0">
        <!-- Modals for History -->
        <b-modal id="modal-received-history" scrollable :title="`RECEIVED HISTORY - ${selectedItem ? selectedItem.product_name : ''}`" size="lg" hide-footer>
            <div v-if="selectedItem">
                <b-card>
                    <b-form @submit.prevent="saveReceivedHistory">
                        <b-form-group label="Add Received Quantity">
                            <b-input type="number" v-model="newReceivedQty" placeholder="Enter quantity" required></b-input>
                        </b-form-group>
                        <b-button type="submit" variant="success" size="sm">Add Received</b-button>
                    </b-form>
                </b-card>

              <b-table striped hover :items="receivedHistory" :fields="historyFields" class="mt-3">
                <template #cell(timestamp)="data">
                    {{ formatDate(data.value) }}
                </template>
                <template #cell(actions)="data">
                    <b-button size="sm" variant="outline-danger" @click="deleteHistoryItem('received', data.item.id)">
                        <b-icon icon="trash"></b-icon>
                    </b-button>
                </template>
            </b-table>
            </div>
        </b-modal>
        
        <!-- Add to Damages Modal - COMPLETELY FIXED -->
        <b-modal 
            id="modal-add-to-damages" 
            scrollable 
            title="ADD ITEM TO DAMAGES" 
            size="lg" 
            @hidden="reset_damages_form"
            no-close-on-backdrop
        >
            <div v-if="selectedItem">
                <b-card class="mb-3">
                    <b-row>
                        <b-col>
                            <strong>Product:</strong> {{ selectedItem.product_name }}
                        </b-col>
                        <b-col>
                            <strong>SKU:</strong> {{ selectedItem.product_sku }}
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col>
                            <strong>Current Location:</strong> {{ packet.locsubsdict[selectedItem.locsub] }}
                        </b-col>
                        <b-col>
                            <strong>Current Stock:</strong> {{ selectedItem.in_stock }}
                        </b-col>
                    </b-row>
                </b-card>

                <!-- REMOVED @submit.prevent from form to prevent duplicate submissions -->
                <b-form>
                    <!-- Source Location (Where to take FROM) -->
                    <b-row>
                        <b-col md="6">
                            <b-form-group label="Source Location" label-for="source-location">
                                <b-form-select
                                    id="source-location"
                                    v-model="newDamageItem.source_locsub"
                                    :options="availableLocations"
                                    required
                                    @change="onSourceLocationChange"
                                >
                                    <template #first>
                                        <b-form-select-option :value="null">Select Source Location</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                         <b-col md="6">
                            <b-form-group label="Target Location" label-for="target-location">
                                <b-form-select
                                    id="target-location"
                                    v-model="newDamageItem.target_locsub"
                                    :options="availableLocations"
                                    required
                                    @change="onTargetLocationChange"
                                >
                                    <template #first>
                                        <b-form-select-option :value="null">Select Target Location</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <!-- Rest of the form remains the same -->
                    <b-row>
                        <b-col md="6">
                            <b-form-group label="Damage Type" label-for="damage-type">
                                <b-form-select
                                    id="damage-type"
                                    v-model="newDamageItem.damage_type"
                                    :options="damageTypeOptions"
                                    required
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group label="Damage Grade" label-for="damage-grade">
                                <b-form-select
                                    id="damage-grade"
                                    v-model="newDamageItem.damage_grade"
                                    :options="damageGradeOptions"
                                    required
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <!-- Pricing -->
                    <b-row>
                        <b-col md="6">
                            <b-form-group label="Original Price" label-for="original-price">
                                <b-form-input
                                    id="original-price"
                                    type="number"
                                    step="0.01"
                                    v-model="newDamageItem.original_price"
                                    placeholder="Enter original price"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group label="Selling Price" label-for="selling-price">
                                <b-form-input
                                    id="selling-price"
                                    type="number"
                                    step="0.01"
                                    v-model="newDamageItem.selling_price"
                                    placeholder="Enter selling price for damaged item"
                                    required
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <!-- Damage Description -->
                    <b-form-group label="Damage Description" label-for="damage-description">
                        <b-form-textarea
                            id="damage-description"
                            v-model="newDamageItem.damage_description"
                            placeholder="Describe the damage in detail..."
                            rows="3"
                        ></b-form-textarea>
                    </b-form-group>

                    <!-- Image Upload -->
                    <b-form-group label="Damage Images" label-for="damage-images">
                        <b-form-file
                            id="damage-images"
                            v-model="damageImages"
                            multiple
                            accept="image/*"
                            placeholder="Choose images or drop them here..."
                            drop-placeholder="Drop images here..."
                            @change="handleImageUpload"
                        ></b-form-file>
                        <small class="text-muted">You can upload multiple images to show the damage</small>
                        
                        <!-- Image Preview -->
                        <div v-if="imagePreviews.length > 0" class="mt-3">
                            <h6>Image Previews:</h6>
                            <div class="d-flex flex-wrap">
                                <div v-for="(preview, index) in imagePreviews" :key="index" class="mr-2 mb-2">
                                    <img :src="preview" alt="Damage preview" style="max-width: 100px; max-height: 100px; object-fit: cover;">
                                    <b-button 
                                        size="sm" 
                                        variant="outline-danger" 
                                        @click="removeImage(index)"
                                        class="mt-1"
                                        style="width: 100%;"
                                    >
                                        Remove
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </b-form-group>
                </b-form>
            </div>
            
            <!-- Modal Footer - ONLY this button triggers the save -->
            <template #modal-footer>
                <b-button variant="secondary" @click="reset_damages_form" :disabled="isSubmitting">Cancel</b-button>
                <b-button 
                    variant="danger" 
                    @click="save_damaged_item"
                    :disabled="isSubmitting"
                >
                    <b-spinner v-if="isSubmitting" small class="mr-2"></b-spinner>
                    {{ isSubmitting ? 'Saving...' : 'Add to AS IS' }}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-missing-history" scrollable :title="`MISSING HISTORY - ${selectedItem ? selectedItem.product_name : ''}`" size="lg" hide-footer>
            <div v-if="selectedItem">
                <b-card>
                    <b-form @submit.prevent="saveMissingHistory">
                        <b-form-group label="Add Missing Quantity">
                            <b-input type="number" v-model="newMissingQty" placeholder="Enter quantity" required></b-input>
                        </b-form-group>
                        <b-button type="submit" variant="warning" size="sm">Add Missing</b-button>
                    </b-form>
                </b-card>

                <b-table striped hover :items="missingHistory" :fields="historyFields" class="mt-3">
                    <template #cell(timestamp)="data">
                        {{ formatDate(data.value) }}
                    </template>
                    <template #cell(actions)="data">
                        <b-button size="sm" variant="outline-danger" @click="deleteHistoryItem('missing', data.item.id)">
                            <b-icon icon="trash"></b-icon>
                        </b-button>
                    </template>
                </b-table>
            </div>
        </b-modal>

        <b-modal id="modal-damages-history" scrollable :title="`DAMAGES HISTORY - ${selectedItem ? selectedItem.product_name : ''}`" size="lg" hide-footer>
            <div v-if="selectedItem">
                <b-card>
                    <b-form @submit.prevent="saveDamagesHistory">
                        <b-form-group label="Add Damages Quantity">
                            <b-input type="number" v-model="newDamagesQty" placeholder="Enter quantity" required></b-input>
                        </b-form-group>
                        <b-button type="submit" variant="danger" size="sm">Add Damages</b-button>
                    </b-form>
                </b-card>

                <b-table striped hover :items="damagesHistory" :fields="historyFields" class="mt-3">
                    <template #cell(timestamp)="data">
                        {{ formatDate(data.value) }}
                    </template>
                    <template #cell(actions)="data">
                        <b-button size="sm" variant="outline-danger" @click="deleteHistoryItem('damages', data.item.id)">
                            <b-icon icon="trash"></b-icon>
                        </b-button>
                    </template>
                </b-table>
            </div>
        </b-modal>

        <b-modal id="modal-sold-history" scrollable :title="`SOLD HISTORY - ${selectedItem ? selectedItem.product_name : ''}`" size="lg" hide-footer>
            <div v-if="selectedItem">
                <b-card>
                    <b-form @submit.prevent="saveSoldHistory">
                        <b-form-group label="Add Sold Quantity">
                            <b-input type="number" v-model="newSoldQty" placeholder="Enter quantity" required></b-input>
                        </b-form-group>
                        <b-button type="submit" variant="info" size="sm">Add Sold</b-button>
                    </b-form>
                </b-card>

                <b-table striped hover :items="soldHistory" :fields="historyFields" class="mt-3">
                    <template #cell(timestamp)="data">
                        {{ formatDate(data.value) }}
                    </template>
                    <template #cell(actions)="data">
                        <b-button size="sm" variant="outline-danger" @click="deleteHistoryItem('sold', data.item.id)">
                            <b-icon icon="trash"></b-icon>
                        </b-button>
                    </template>
                </b-table>
            </div>
        </b-modal>

        <!-- Edit Modals -->
        <b-modal id="modal-edit-received" title="Edit Received Quantity" @ok="saveEditedReceived">
            <b-form-group label="Received Quantity">
                <b-input type="number" v-model="editReceivedQty" required></b-input>
            </b-form-group>
        </b-modal>

        <b-modal id="modal-edit-missing" title="Edit Missing Quantity" @ok="saveEditedMissing">
            <b-form-group label="Missing Quantity">
                <b-input type="number" v-model="editMissingQty" required></b-input>
            </b-form-group>
        </b-modal>

        <b-modal id="modal-edit-damages" title="Edit Damages Quantity" @ok="saveEditedDamages">
            <b-form-group label="Damages Quantity">
                <b-input type="number" v-model="editDamagesQty" required></b-input>
            </b-form-group>
        </b-modal>

        <b-modal id="modal-edit-sold" title="Edit Sold Quantity" @ok="saveEditedSold">
            <b-form-group label="Sold Quantity">
                <b-input type="number" v-model="editSoldQty" required></b-input>
            </b-form-group>
        </b-modal>

        <b-modal id="modal-reserved-invoices" scrollable :title="`RESERVED INVOICES - ${selectedItem ? selectedItem.product_name : ''}`" size="lg" hide-footer>
    <div v-if="selectedItem">
        <b-card class="mb-3">
            <b-row>
                <b-col>
                    <strong>SKU:</strong> {{ selectedItem.product_sku }}
                </b-col>
                <b-col>
                    <strong>Location:</strong> {{ packet.locsubsdict[selectedItem.locsub] }}
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col>
                    <strong>Total Reserved:</strong> {{ selectedItem.total_reserved }}
                </b-col>
                <b-col>
                    <strong>Total Invoices:</strong> {{ selectedItem.total_invoices }}
                </b-col>
            </b-row>
        </b-card>

        <b-table striped hover :items="reservedInvoices" :fields="reservedInvoiceFields" class="mt-3">
            <template #cell(invoice_id)="data">
                <a :href="`http://inventory.myfurnituremecca.com/#/sales/viewsale/${data.value}/`"
                   target="_blank"
                   class="invoice-link">
                    {{ data.value }}
                    <b-icon icon="box-arrow-up-right" scale="0.8"></b-icon>
                </a>
            </template>
            <template #cell(invoice_date)="data">
                {{ formatDate(data.value) }}
            </template>
            <template #cell(reserved_quantity)="data">
                {{ data.value }}
            </template>
            <template #cell(invoice_completed)="data">
                <b-badge :variant="data.value ? 'success' : 'warning'">
                    {{ data.value ? 'Completed' : 'Pending' }}
                </b-badge>
            </template>
        </b-table>

        <div v-if="reservedInvoices.length === 0" class="text-center text-muted p-4">
            <b-icon icon="file-earmark-x" font-scale="2"></b-icon>
            <p class="mt-2">No reserved invoices found for this item</p>
        </div>
    </div>
</b-modal>

        <!-- Main Content -->
        <div
          v-if="isMobile"
          class="d-flex justify-content-between align-items-center mb-2 py-2"
        >
          <b-button
            size="sm"
            variant="outline-primary"
            @click="filtersVisible = !filtersVisible"
          >
            <b-icon-funnel-fill class="mr-1" />
            {{ filtersVisible ? "Hide Filters" : "Show Filters" }}
          </b-button>
        </div>

        <div class="d-flex flex-column flex-lg-row" style="gap: 7px;">
          <b-card style="display: inline-block; width: 100%; vertical-align: top;" :style="{'max-width': isMobile ? 'none' : '300px'}">
              <div>LOCATION</div>
              <div>
                  <b-form-select
                      :options="locations"
                      v-model="location_id"
                      @change="get_inventory_for_location"
                      style="width: 100%;"
                      :style="{'max-width': isMobile ? 'none' : '250px'}"
                  >
                      <template #first>
                          <b-form-select-option :value="null" :disabled="true">PICK A LOCATION</b-form-select-option>
                      </template>
                  </b-form-select>
              </div>
          </b-card>

          <b-collapse :visible="!isMobile || filtersVisible" style="width: 100%;">
              <b-card style="display: inline-block; width: 100%; vertical-align: top;" v-if="items.length > 0" :style="{'max-width': isMobile ? 'none' : '300px'}">
                  <div>FILTER SUBLOCATION</div>
                  <div>
                      <b-form-select
                          :options="packet.locsubs.filter(d => d.location_id == location_id)"
                          v-model="picked_locsub"
                          style="width: 100%;"
                          :style="{'max-width': isMobile ? 'none' : '250px'}"
                      >
                          <template #first>
                              <b-form-select-option :value="null">ALL</b-form-select-option>
                          </template>
                      </b-form-select>
                  </div>
              </b-card>

              <b-card style="display: inline-block; width: 100%; vertical-align: top;" v-if="items.length > 0" :style="{'max-width': isMobile ? 'none' : '300px'}">
                  <div>FILTER CATEGORY</div>
                  <div>
                      <b-form-select
                          :options="categoryOptions"
                          v-model="picked_category"
                          style="width: 100%;"
                          :style="{'max-width': isMobile ? 'none' : '250px'}"
                      >
                          <template #first>
                              <b-form-select-option :value="null">ALL</b-form-select-option>
                          </template>
                      </b-form-select>
                  </div>
              </b-card>

              <b-card style="display: inline-block; max-width: auto; vertical-align: top;" v-if="items.length > 0">
                  <div>
                      <div style="margin: 3px; display: inline-block; vertical-align: top;">
                          <div v-if="!hide_zero_in_stock">
                              <b-button variant="success" size="sm" @click="hide_zero_in_stock = !hide_zero_in_stock">
                                  HIDE 0 IN-STOCK
                              </b-button>
                          </div>
                          <div v-else>
                              <b-button variant="warning" size="sm" @click="hide_zero_in_stock = !hide_zero_in_stock">
                                  SHOW 0 IN-STOCK
                              </b-button>
                          </div>
                      </div>

                      <div style="margin: 3px; display: inline-block; vertical-align: top;">
                          <b-button variant="success" size="sm" @click="get_inventory_for_location">REFRESH</b-button>
                      </div>

                      <div style="margin: 3px; display: inline-block; vertical-align: top;" v-if="packet.userDetails.userrole == 'admin'">
                          <b-button variant="info" size="sm" @click="downloadExcel">DOWNLOAD EXCEL</b-button>
                      </div>
                  </div>

                  <div style="margin-top: 5px;">
                      <b-form-input
                          v-model="search_txt"
                          size="sm"
                          placeholder="SEARCH PRODUCT IN RESULTS"
                      ></b-form-input>
                  </div>
              </b-card>

          </b-collapse>
        </div>

        <b-card style="margin-top: 10px; min-height: 250px; max-height: 100%; overflow-y: scroll;" ref="scrollContainer">
            <div v-if="items_being_loaded">
                <loading
                    :active="true"
                    :can-cancel="false"
                    :is-full-page="false">
                </loading>
            </div>

            <div v-else>
                <div v-if="items.length == 0">
                    <b-alert variant="warning" show>NO INVENTORY FOR THIS LOCATION</b-alert>
                </div>

                <div v-else style="overflow-x: auto;">
                    <!-- Removed Pagination Info -->
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                                <th class="ipt_tdhr" @click="sortby('product_name')" style="min-width: 150px;">
                                    PRODUCT NAME
                                </th>
                                <th class="ipt_tdhr" @click="sortby('product_sku')" style="min-width: 80px;">
                                    PRODUCT SKU
                                </th>
                                <th class="ipt_tdhr" @click="sortby('category')" style="min-width: 70px;">
                                    CATEGORY
                                </th>
                                <th class="ipt_tdhr" @click="sortby('locsub')"  style="min-width: 70px;">
                                    SUBLOCATION
                                </th>
                                <th class="ipt_tdhr" @click="sortby('selling_price')" v-if="packet.userDetails.userrole == 'admin'"  style="min-width: 100px;">
                                    SALE PRICE
                                </th>
                                <th class="ipt_tdhr" @click="sortby('wholesale_price')" v-if="packet.userDetails.userrole == 'admin'"  style="min-width: 100px;">
                                    WHOLESALE PRICE
                                </th>
                                <th class="ipt_tdhr" @click="sortby('landed_cost')" v-if="packet.userDetails.userrole == 'admin'"  style="min-width: 100px;">
                                    LANDED COST
                                </th>
                                <th class="ipt_tdhr" @click="sortby('in_stock')"  style="min-width: 70px;">
                                    IN STOCK
                                </th>
                                <th class="ipt_tdhr" @click="sortby('reserved')"  style="min-width: 70px;">
                                    RESERVED
                                </th>
                                <th class="ipt_tdhr" @click="sortby('available')"  style="min-width: 70px;">
                                    AVAILABLE
                                </th>

                                <th class="ipt_tdhr"  style="min-width: 270px;">
                                    ACTIONS
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td class="ipt_tdhr" style="font-weight: normal; background-color: lightyellow;"></td>
                                <td class="ipt_tdhr" style="font-weight: normal; background-color: lightyellow;"></td>
                                <td class="ipt_tdhr" style="font-weight: normal; background-color: lightyellow;"></td>
                                <td class="ipt_tdhr" style="font-weight: bold; background-color: lightyellow;"></td>
                                <td class="ipt_tdhr" style="font-weight: bold; background-color: lightyellow;" v-if="packet.userDetails.userrole == 'admin'">
                                    $ {{ numberWithCommas((total('selling_price', 'in_stock') || 0.0).toFixed(2)) }}
                                </td>
                                <td class="ipt_tdhr" style="font-weight: bold; background-color: lightyellow;" v-if="packet.userDetails.userrole == 'admin'">
                                    $ {{ numberWithCommas((total('wholesale_price', 'in_stock') || 0.0).toFixed(2)) }}
                                </td>
                                <td class="ipt_tdhr" style="font-weight: bold; background-color: lightyellow;" v-if="packet.userDetails.userrole == 'admin'">
                                    $ {{ numberWithCommas((total('landed_cost', 'in_stock') || 0.0).toFixed(2))  }}
                                </td>
                                <td class="ipt_tdhr" style="font-weight: bold; background-color: lightyellow;">
                                    {{ total('in_stock') }}
                                </td>
                                <td class="ipt_tdhr" style="font-weight: bold; background-color: lightyellow;">
                                    {{ total('reserved') }}
                                </td>
                                <td class="ipt_tdhr" style="font-weight: bold; background-color: lightyellow;">
                                    {{ total('available') }}
                                </td>

                                <td class="ipt_tdhr" style="font-weight: bold; background-color: lightyellow;"></td>
                            </tr>
                        </tbody>

                        <tbody>
                            <tr v-for="item,idx in displayedItems" v-bind:key="idx" v-if="allowed(item)">
                                <td class="ipt_tdhr" style="font-weight: normal;">
                                    {{ item.product_name }}
                                </td>
                                <td class="ipt_tdhr" style="font-weight: normal;">
                                    {{ item.product_sku }}
                                </td>
                                <td class="ipt_tdhr" style="font-weight: normal;">
                                    {{ item.category }}
                                </td>
                                <td class="ipt_tdhr" style="font-weight: normal;">
                                    {{ packet.locsubsdict[item.locsub] }}
                                </td>

                                <td class="ipt_tdhr" style="font-weight: normal;" v-if="packet.userDetails.userrole == 'admin'">
                                    $ {{ (item.selling_price || 0.0).toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr" style="font-weight: normal;" v-if="packet.userDetails.userrole == 'admin'">
                                    $ {{ (item.wholesale_price || 0.0).toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr" style="font-weight: normal;" v-if="packet.userDetails.userrole == 'admin'">
                                    $ {{ (item.landed_cost || 0.0).toFixed(2) }}
                                </td>

                                <td class="ipt_tdhr" style="font-weight: normal;">
                                    <span v-if="item.edit_in_stock && !item.is_out_of_stock">
                                        <span><b-input size="sm" v-model="item.in_stock_fake" style="width: 80px;" :disabled="item.is_out_of_stock"></b-input></span>
                                        <span><b-badge href="#" variant="success" @click="save_in_stock(item)" :disabled="item.is_out_of_stock">SAVE</b-badge></span>
                                        <span><b-badge href="#" variant="secondary" @click="cancel_save_in_stock(item)">CANCEL</b-badge></span>
                                    </span>

                                    <span v-else>
                                        <span v-if="(packet.userDetails.userrole == 'admin' || packet.userDetails.userrole == 'officemanager') && !item.is_out_of_stock">
                                            <b-icon icon="pencil-square" scale="0" variant="success" @click="edit_in_stock(item)"></b-icon>
                                        </span>
                                        <span>{{ (item.in_stock || 0) }}</span>
                                    </span>
                                </td>
                               <td class="ipt_tdhr" style="font-weight: normal;">
    <span class="clickable-cell"
          @click="show_reserved_invoices(item)"
          title="Click to view reserved invoices"
          :class="{'': item.reserved > 0}">
            <b-icon icon="clipboard-check" style="color: orange;" scale="1"  v-if="item.reserved > 0"></b-icon>
        {{ (item.reserved || 0) }}

    </span>
</td>
                                <td class="ipt_tdhr" style="font-weight: normal;">
                                    {{ (item.available || 0) }}
                                </td>

                                <td class="ipt_tdhr" style="font-weight: normal; padding: 3px; max-width: 350px;">
                                    <button @click="move_items(item)" v-if="item.move_items == false && packet.userDetails.userrole == 'admin' ||
                                    packet.userDetails.userrole == 'accountmanager' ||
                                    packet.userDetails.userrole == 'officemanager' ||
                                    packet.userDetails.userrole == 'officeuser' || packet.userDetails.userrole == 'warehousemanager'  || packet.userDetails.userrole == 'locationadmin'  ">MOVE ITEMS</button>
                                       <button @click="show_add_to_damages(item)" v-if="packet.userDetails.userrole == 'admin' || packet.userDetails.userrole == 'officemanager'" style="margin-left: 5px; background-color: #dc3545; color: white; border: none; padding: 4px 8px; border-radius: 3px;">
                                        ADD TO AS IS
                                    </button>
                                    <div v-if="item.move_items" style="text-align: left; width: 350px; margin: auto;">
                                        <div style="margin: 5px; font-size: 12px;">
                                            <div>FROM:</div>
                                            <b-alert show variant="warning">{{ packet.locsubsdict[item.locsub]}}
                                            </b-alert>
                                        </div>
                                        <div style="margin: 5px; font-size: 12px;">
                                            <div>TO:</div>
                                            <b-alert variant="warning" show><b-form-select size="sm" style="width: 300px; font-size: 12px;" :options="packet.locsubs" v-model="item.to_locsub"></b-form-select></b-alert>
                                        </div>
                                        <div style="margin: 5px; font-size: 12px;">
                                            <div>QTY:</div>
                                            <b-alert variant="warning" show>
                                                <input v-model="item.move_quantity" style="width: 50px; font-weight: bold;"></input>
                                            </b-alert>
                                        </div>
                                        <button @click="cancel_move(item)">CANCEL MOVE</button>
                                        <button @click="submit_move_wrapper(item)">SUBMIT</button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                    <!-- Removed Load More button -->
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
    import moment from 'moment'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { BIconFunnelFill } from "bootstrap-vue";

    import ItemComments from '@/components/importables/ItemComments'

    export default {
        name: "InventoryByLocation",
        components: {flatPickr, Loading, ItemComments},
        data: function(){
            return {
                items: [], // All items
                displayedItems: [], // Items currently displayed
                newDamageItem: {
                    source_locsub: null,
                    source_sublocation_id: null,
                    target_locsub: null,
                    target_sublocation_id: null,
                    damage_type: '',
                    damage_grade: 'moderate',
                    damage_description: '',
                    original_price: null,
                    selling_price: null,
                    quantity: 1
                },
                damageImages: [],
                availableLocations: [],   
                imagePreviews: [],
                damageTypeOptions: [
                    { value: 'customer_return', text: 'Customer Return' },
                    { value: 'shipping', text: 'Shipping Damage' },
                    { value: 'warehouse_handling', text: 'Warehouse Handling' },
                    { value: 'vendor_fault', text: 'Vendor Fault' },
                    { value: 'quality_control', text: 'Quality Control' },
                    { value: 'other', text: 'Other' }
                ],
                damageGradeOptions: [
                    { value: 'light', text: 'Light Damage' },
                    { value: 'moderate', text: 'Moderate Damage' },
                    { value: 'heavy', text: 'Heavy Damage' }
                ],
                locations: [],
                location_id:null,
                packet: {},
                items_being_loaded: false,
                item_comments_invoice_id: null,
                item_comments_itemid: null,
                picked_locsub: null,
                sort_asc: false,
                hide_zero_in_stock: false,
                search_txt: "",
                picked_category: null,
                categoryOptions: [],
                reservedInvoices: [],
                reservedInvoiceFields: [
                    { key: 'invoice_id', label: 'INVOICE ID', sortable: true },
                    { key: 'reserved_quantity', label: 'RESERVED QTY', sortable: true },
                    { key: 'invoice_date', label: 'INVOICE DATE', sortable: true },
                    { key: 'invoice_completed', label: 'STATUS', sortable: true }
                ],

                // New data properties for history modals
                selectedItem: null,
                receivedHistory: [],
                missingHistory: [],
                damagesHistory: [],
                soldHistory: [],
                newReceivedQty: 0,
                newMissingQty: 0,
                newDamagesQty: 0,
                newSoldQty: 0,
                editReceivedQty: 0,
                editMissingQty: 0,
                editDamagesQty: 0,
                editSoldQty: 0,
                historyFields: [
                    { key: 'timestamp', label: 'DATE', sortable: true },
                    { key: 'changed_by', label: 'BY', sortable: true },
                    { key: 'quantity', label: 'QTY', sortable: true },
                    { key: 'sublocation_name', label: 'LOC', sortable: true },
                    { key: 'source', label: 'SOURCE', sortable: true },
                    { key: 'actions', label: 'ACTION' }
                ],
                filtersVisible: false,
                isMobile: false,
                // CRITICAL FIX: Added isSubmitting flag to prevent multiple submissions
                isSubmitting: false,
            }
        },
        watch: {
            items(newItems) {
                let categories = [...new Set(newItems.map(i => i.category).filter(Boolean))];
                this.categoryOptions = categories.map(c => ({
                    value: c,
                    text: c
                }));
            },
            // Watch for filter changes to update displayed items
            picked_locsub() {
                this.updateDisplayedItems();
            },
            picked_category() {
                this.updateDisplayedItems();
            },
            hide_zero_in_stock() {
                this.updateDisplayedItems();
            },
            search_txt() {
                this.updateDisplayedItems();
            }
        },
        computed: {
            filteredSourceSublocations() {
                if (!this.newDamageItem.source_locsub) return [];
                let locationId = parseInt(this.newDamageItem.source_locsub);
                return this.packet.locsubs.filter(loc => {
                    let locParts = loc.value.split("|");
                    return parseInt(locParts[0]) === locationId;
                }).map(loc => {
                    let locParts = loc.value.split("|");
                    return {
                        value: loc.value,
                        text: loc.text.split(' - ')[1] || loc.text // Show only sublocation part
                    };
                });
            },
            filteredTargetSublocations() {
                if (!this.newDamageItem.target_locsub) return [];
                let locationId = parseInt(this.newDamageItem.target_locsub);
                return this.packet.locsubs.filter(loc => {
                    let locParts = loc.value.split("|");
                    return parseInt(locParts[0]) === locationId;
                }).map(loc => {
                    let locParts = loc.value.split("|");
                    return {
                        value: loc.value,
                        text: loc.text.split(' - ')[1] || loc.text // Show only sublocation part
                    };
                });
            },
            availableLocations() {
                // Get unique main locations only
                const uniqueLocations = [];
                const seenLocations = new Set();
                
                this.packet.locsubs.forEach(loc => {
                    let locParts = loc.value.split("|");
                    let locationId = locParts[0];
                    let locationName = loc.text.split(' - ')[0]; // Get main location name only
                    
                    if (!seenLocations.has(locationId)) {
                        seenLocations.add(locationId);
                        uniqueLocations.push({
                            value: locationId, // Store only location ID without sublocation
                            text: locationName // Show only main location name
                        });
                    }
                });
                
                return uniqueLocations;
            },

            orderedTotal() {
                return this.items
                .filter(item => this.allowed(item))
                .reduce((sum, item) => sum + Number(item.ordered || 0), 0);
            },
            scheduledTotal() {
                return this.items
                .filter(item => this.allowed(item))
                .reduce((sum, item) => sum + Number(item.scheduled || 0), 0);
            },
            soldsofarTotal() {
                return this.items
                .filter(item => this.allowed(item))
                .reduce((sum, item) => sum + Number(item.sold_so_far || 0), 0);
            }
        },
        mounted() {
          this.handleResize();
          window.addEventListener("resize", this.handleResize);
        },
        beforeDestroy() {
          window.removeEventListener("resize", this.handleResize);
        },
        methods: {
          handleResize() {
            this.isMobile = window.innerWidth < 768
          },
          
          async get_inventory_for_location() {
            this.items_being_loaded = true;

            try {
                let path = "/api/inventory/get_inventory_for_location/";
                let data = {
                    location_id: this.location_id ? parseInt(this.location_id) : null
                };

                const response = await new Promise((resolve, reject) => {
                    Requestor.getSyncP(path, data, this, resolve, reject);
                });

                if (response.data.error) {
                    this.$bvToast.toast(
                        response.data.error,
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return;
                }

                this.items = response.data.result.map(item => ({
                    ...item,
                    received: item.received || 0,
                    missing: item.missing || 0,
                    damages: item.damages || 0,
                    sold: item.sold || 0,
                    edit_received: false,
                    edit_missing: false,
                    edit_damages: false,
                    edit_sold: false,
                    received_fake: item.received || 0,
                    missing_fake: item.missing || 0,
                    damages_fake: item.damages || 0,
                    sold_fake: item.sold || 0
                }));

                this.updateDisplayedItems();

            } catch (error) {
                console.error('Error fetching inventory:', error);
                this.$bvToast.toast(
                    "Error retrieving inventory for location.",
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
            } finally {
                this.items_being_loaded = false;
            }
          },

          updateDisplayedItems() {
            // Apply filters to all items
            this.displayedItems = this.items.filter(item => this.allowed(item));
          },

          show_add_to_damages: function(item) {
            this.selectedItem = item;
            
            // Pre-populate form with item data
            this.newDamageItem.original_price = item.selling_price || null;
            this.newDamageItem.selling_price = Math.round((item.selling_price || 0) * 0.5 * 100) / 100;
            this.newDamageItem.quantity = 1;
            this.newDamageItem.damage_type = 'warehouse_handling';
            this.newDamageItem.damage_grade = 'moderate';
            
            // Set current location as default for both source and target
            this.newDamageItem.source_locsub = item.locsub;
            this.newDamageItem.target_locsub = item.locsub; // Default target is same as source
            
            // Populate available locations
            this.availableLocations = this.packet.locsubs.filter(loc => {
                return true; // Add any filtering logic here if needed
            });
            
            // Reset submitting flag when opening modal
            this.isSubmitting = false;
            
            this.$bvModal.show('modal-add-to-damages');
          },
    
          handleImageUpload: function(event) {
            const files = event.target.files;
            this.imagePreviews = [];
            
            for (let file of files) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imagePreviews.push(e.target.result);
                };
                reader.readAsDataURL(file);
            }
          },
          
          getMaxAvailableQuantity: function() {
            if (!this.selectedItem || !this.newDamageItem.source_locsub) {
                return this.selectedItem ? this.selectedItem.in_stock : 0;
            }
            
            // If source is the current item's location, use its stock
            if (this.newDamageItem.source_locsub === this.selectedItem.locsub) {
                return this.selectedItem.in_stock;
            }
            
            // Otherwise, you might want to fetch stock for the selected source location
            // For now, return a safe default
            return this.selectedItem.in_stock;
          },
          
          removeImage: function(index) {
            this.imagePreviews.splice(index, 1);
            // Also remove from file input if needed
          },
    
          reset_damages_form: function() {
            this.newDamageItem = {
                source_locsub: null,
                source_sublocation_id: null,
                target_locsub: null,
                target_sublocation_id: null,
                damage_type: '',
                damage_grade: 'moderate',
                damage_description: '',
                original_price: null,
                selling_price: null,
                quantity: 1
            };
            this.damageImages = [];
            this.imagePreviews = [];
            this.availableLocations = [];
            this.isSubmitting = false; // Reset submitting flag
            this.$bvModal.hide('modal-add-to-damages');
          },
    
          // CRITICAL FIX: Added isSubmitting check to prevent multiple submissions
          save_damaged_item: function() {
            // Prevent multiple submissions
            if (this.isSubmitting) {
                console.log('Submission already in progress, ignoring duplicate click');
                return;
            }
            
            if (!this.validate_damage_form()) {
                return;
            }
            
            this.isSubmitting = true;
            
            console.log('Image previews before sending:', this.imagePreviews); // Debug log
            
            // Use the combined locsub format (like "25|62") instead of separate IDs
            let data = {
                product_id: this.selectedItem.product_id,
                product_sku: this.selectedItem.product_sku,
                
                // Use the combined locsub format that your backend expects
                source_locsub: this.newDamageItem.source_locsub,
                target_locsub: this.newDamageItem.target_locsub,
                
                quantity: this.newDamageItem.quantity,
                damage_type: this.newDamageItem.damage_type,
                damage_grade: this.newDamageItem.damage_grade,
                damage_description: this.newDamageItem.damage_description,
                original_price: this.newDamageItem.original_price,
                selling_price: this.newDamageItem.selling_price,
                images: this.imagePreviews, // This should now contain the base64 data URLs
                username: this.packet.userDetails.username
            };
            
            console.log('Final payload with images:', data); // Debug log
            
            let path = "/api/inventory/add_to_damages/";
            let that = this;
            
            let s = function(response) {
                console.log('Add to damages response:', response.data);
                that.isSubmitting = false; // Reset flag on success
                if (response.data.error) {
                    that.$bvToast.toast(
                        response.data.error,
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                } else {
                    that.$bvToast.toast(
                        "ITEM ADDED TO DAMAGES SUCCESSFULLY!",
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                    that.reset_damages_form();
                    that.get_inventory_for_location();
                    
                    if (that.selectedItem) {
                        that.fetchSingleItemDamagesCount(that.selectedItem);
                    }
                }
            }
            
            let f = function(error) {
                console.error('Add to damages error:', error);
                that.isSubmitting = false; // Reset flag on error
                that.$bvToast.toast(
                    "Error adding item to damages. Please try again.",
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
            }
            
            Requestor.postAsyncP(path, data, this, s, f);
          },
      
    
          validate_damage_form: function() {
            // Check if source and target are different
            if (this.newDamageItem.source_locsub === this.newDamageItem.target_locsub) {
                this.$vex.dialog.alert({
                    message: "Source and target locations cannot be the same. Please select different locations."
                });
                return false;
            }
            
            // Check quantity
            if (this.newDamageItem.quantity > this.getMaxAvailableQuantity()) {
                this.$vex.dialog.alert({
                    message: `Cannot mark more than available stock. Available from source: ${this.getMaxAvailableQuantity()}`
                });
                return false;
            }
            
            if (!this.newDamageItem.damage_type) {
                this.$vex.dialog.alert({
                    message: "Please select a damage type"
                });
                return false;
            }
            
            if (!this.newDamageItem.selling_price) {
                this.$vex.dialog.alert({
                    message: "Please enter a selling price for the damaged item"
                });
                return false;
            }
            
            return true;
          },
          
          show_reserved_invoices: function(item) {
            this.selectedItem = item;

            // Check if we have invoice data
            if (item.invoices && item.invoices.length > 0) {
                this.reservedInvoices = item.invoices;
            } else {
                this.reservedInvoices = [];
            }

            this.$bvModal.show('modal-reserved-invoices');
          },
          
          formatDate: function(dateString) {
            // Handle both ISO format and GMT format
            if (dateString.includes('GMT')) {
                return moment(dateString).format('DD-MM-YYYY');
            } else {
                return moment(dateString).format('DD-MM-YYYY');
            }
          },
          
          allowed: function(row){
            let status = true;
            let that = this;

            function picked_locsub_fn(row){
                let status = true;
                if (that.picked_locsub != null){
                    if (row.locsub != that.picked_locsub){
                        status = false
                    }
                    else {
                        status = true
                    }
                }
                return status
            }

            function picked_category_fn(row){
                let status = true;
                if (that.picked_category != null){
                    if (row.category != that.picked_category){
                        status = false;
                    }
                }
                return status
            }

            function hide_zero_in_stock_fn(row){
                let status = true;
                if (that.hide_zero_in_stock){
                    if (row.in_stock == 0){
                        status = false;
                    }
                }
                return status
            }

            function search_txt_fn(row){
                let status = true;
                let product_sku = row.product_sku;
                let product_name = row.product_name;
                status = (
                    product_name.toLowerCase().indexOf(that.search_txt.toLowerCase()) > -1
                    ||
                    product_sku.toLowerCase().indexOf(that.search_txt.toLowerCase()) > -1
                );
                return status
            }

            if ((picked_locsub_fn(row) == false) ||
                (picked_category_fn(row) == false) ||
                (hide_zero_in_stock_fn(row) == false) ||
                (search_txt_fn(row) == false)){
                status = false
            }

            return status
          },

          downloadExcel: function() {
            let filtered = this.displayedItems.filter(row => this.allowed(row));

            if (filtered.length === 0) {
                alert("No data to export!");
                return;
            }

            let ws_data = filtered.map(item => ({
                Product: item.product_name,
                SKU: item.product_sku,
                Category: item.category,
                Sublocation: this.packet.locsubsdict[item.locsub],
                Ordered: item.ordered || 0,
                Scheduled: item.scheduled || 0,
                InStock: item.in_stock,
                Reserved: item.reserved,
                Available: item.available,
                Received: item.received || 0,
                Missing: item.missing || 0,
                Damages: item.damages || 0,
                Sold: item.sold || 0,
                SellingPrice: item.selling_price,
                WholesalePrice: item.wholesale_price,
                LandedCost: item.landed_cost,
            }));

            function escapeCSV(value) {
                if (value === null || value === undefined) return "";
                value = value.toString();
                if (/[",\n]/.test(value)) {
                    value = '"' + value.replace(/"/g, '""') + '"';
                }
                return value;
            }

            let headers = Object.keys(ws_data[0]).map(escapeCSV).join(",");
            let rows = ws_data.map(obj => Object.values(obj).map(escapeCSV).join(",")).join("\n");

            let csvContent = "data:text/csv;charset=utf-8," + headers + "\n" + rows;

            let encodedUri = encodeURI(csvContent);
            let link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "inventory_export.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          },

          submit_move_wrapper: function(item){
            if (!item.to_locsub){
               this.$vex.dialog.alert({
                    message: "Please select a target location to move items to."
                });
                return
            }

            if (item.locsub == item.to_locsub){
               this.$vex.dialog.alert({
                    message: "Cannot move inventory into the same location."
                });
                return
            }

            item.move_quantity = parseInt(item.move_quantity)
            item.in_stock = parseInt(item.in_stock);

            if (isNaN(item.move_quantity)){
                this.$vex.dialog.alert({
                    message: "Please enter a valid quantity to move."
                });
                return
            }
            else {
                if (item.move_quantity > item.in_stock){
                   this.$vex.dialog.alert({
                        message: "You cannot move more than available items."
                    });
                    return
                }
                else {
                    this.submit_move(item);
                }
            }
          },

          submit_move: function(item){
            let path = "/api/inventory/move_inventory/"
            let data = {
                product_id: item.product_id,
                product_sku: item.product_sku,
                from_locsub: item.locsub,
                to_locsub: item.to_locsub,
                move_quantity: item.move_quantity,
                username: this.packet.userDetails.username,
            }
            let that = this;
            let s = function(response) {
                if (response.data.result){
                    that.$bvToast.toast(
                        "MOVE SUCCESSFUL!",
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                    that.get_inventory_for_location()

                }
                else {
                    that.$bvToast.toast(
                        "ERROR MOVING INVENTORY",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    console.log(response.data.error);
                }
                that.items_being_loaded = false;
            }

            let f = function(error) {
                that.$bvToast.toast(
                    "Error moving inventory between locations.",
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
                that.items_being_loaded = false;
            }

            this.items_being_loaded = true;
            Requestor.postSyncP(path, data, this, s, f);
          },

          cancel_move: function(item){
            item.move_items = false;
          },

          move_items: function(item){
            item.move_items = true;
          },

          sortby: function(key){
            if (this.sort_asc){
                this.displayedItems = Requestor.sort(this.displayedItems, key)
            }
            else {
                this.displayedItems = Requestor.sort_reverse(this.displayedItems, key)
            }
            this.sort_asc = !this.sort_asc;
          },

          total: function(key, qty){
            let that = this;
            let out = 0.0;
            if (qty){
                out = this.displayedItems.filter(function(d){return that.allowed(d) == true }).map(function(d){return d[key] * d.in_stock }).reduce((a, b) => a + b, 0)
            }
            else {
                out = this.displayedItems.filter(function(d){return that.allowed(d) == true }).map(function(d){return d[key] }).reduce((a, b) => a + b, 0)
            }
            return out
          },

          numberWithCommas: function(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          },

          fetch_prereqs: function(){
            // Implementation if needed
          },

          edit_in_stock: function(item){
            item.edit_in_stock = true;
            return
          },

          cancel_save_in_stock: function(item){
            item.edit_in_stock = false;
            return
          },

          save_in_stock: function(item){
            let product_sku=item.product_sku;
            let splitted = item.locsub.split("|");
            let location_id = parseInt(splitted[0]);
            let sublocation_id = parseInt(splitted[1]);
            let nitems = parseInt(item.in_stock_fake);
            if (isNaN(nitems)){
                this.$vex.dialog.alert({
                    message: "Please specify a valid quantity for the item"
                });
                return
            }
            if (isNaN(location_id) || isNaN(sublocation_id)){
                this.$vex.dialog.alert({
                    message: "Invalid location for the item. Please refresh the page."
                });
                return
            }
            if (!product_sku){
                this.$vex.dialog.alert({
                    message: "Invalid product. Please refresh the page."
                });
                return
            }
            let data = {
                product_sku: product_sku,
                location_id: location_id,
                sublocation_id: sublocation_id,
                nitems: nitems
            };

            let path = "/api/inventory/update_inventory/"
            let that = this;
            let s = function(response) {
                if (response.data.error){
                    that.$bvToast.toast(
                        response.data.error,
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                else {
                    that.$bvToast.toast(
                        "UPDATED PRODUCT INVENTORY.",
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                    item.edit_in_stock=false;
                    item.in_stock = parseInt(item.in_stock_fake);
                }
            }

            let f = function(error) {
                that.$bvToast.toast(
                    "Error updating inventory. Please try again later.",
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
                item.edit_in_stock=false;

            }
            Requestor.postAsyncP(path, data, this, s, f);
            return
          },

          // NEW METHODS FOR RECEIVED, MISSING, DAMAGES, SOLD
          edit_received: function(item) {
            item.edit_received = true;
            item.received_fake = item.received || 0;
          },

          cancel_save_received: function(item) {
            item.edit_received = false;
          },

          save_received: function(item) {
            this.updateInventoryField(item, 'received', item.received_fake, 'RECEIVED');
          },

          edit_missing: function(item) {
            item.edit_missing = true;
            item.missing_fake = item.missing || 0;
          },

          cancel_save_missing: function(item) {
            item.edit_missing = false;
          },

          save_missing: function(item) {
            this.updateInventoryField(item, 'missing', item.missing_fake, 'MISSING');
          },

          edit_damages: function(item) {
            item.edit_damages = true;
            item.damages_fake = item.damages || 0;
          },

          cancel_save_damages: function(item) {
            item.edit_damages = false;
          },

          save_damages: function(item) {
            this.updateInventoryField(item, 'damages', item.damages_fake, 'DAMAGES');
          },

          edit_sold: function(item) {
            item.edit_sold = true;
            item.sold_fake = item.sold || 0;
          },

          cancel_save_sold: function(item) {
            item.edit_sold = false;
          },

          save_sold: function(item) {
            this.updateInventoryField(item, 'sold', item.sold_fake, 'SOLD');
          },

          updateInventoryField: function(item, field, value, fieldName) {
            console.log('Updating field:', field, 'with value:', value, 'for item:', item);

            let splitted = item.locsub.split("|");
            let location_id = parseInt(splitted[0]);
            let sublocation_id = parseInt(splitted[1]);

            console.log('Parsed location data:', {
                location_id: location_id,
                sublocation_id: sublocation_id,
                product_sku: item.product_sku
            });

            if (isNaN(value)) {
                this.$vex.dialog.alert({
                    message: `Please specify a valid quantity for ${fieldName}`
                });
                return;
            }

            let data = {
                product_sku: item.product_sku,
                location_id: location_id,
                sublocation_id: sublocation_id,
                field: field,
                value: parseInt(value),
                username: this.packet.userDetails.username
            };

            console.log('Sending data to backend:', data);

            let path = "/api/inventory/update_inventory_field/";
            let that = this;
            let s = function(response) {
                console.log('Backend response:', response.data);
                if (response.data.error) {
                    that.$bvToast.toast(
                        response.data.error,
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                } else {
                    that.$bvToast.toast(
                        `UPDATED ${fieldName} QUANTITY.`,
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                    item[field] = parseInt(value);
                    item[`edit_${field}`] = false;
                }
            }

            let f = function(error) {
                console.error('Request failed:', error);
                that.$bvToast.toast(
                    `Error updating ${fieldName.toLowerCase()} quantity. Please try again later.`,
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
                item[`edit_${field}`] = false;
            }

            Requestor.postAsyncP(path, data, this, s, f);
          },
          
          // HISTORY METHODS
          show_received_history: function(item) {
            this.selectedItem = item;
            this.fetchHistory('received');
            this.$bvModal.show('modal-received-history');
          },

          show_missing_history: function(item) {
            this.selectedItem = item;
            this.fetchHistory('missing');
            this.$bvModal.show('modal-missing-history');
          },

          show_damages_history: function(item) {
            this.selectedItem = item;
            this.fetchHistory('damages');
            this.$bvModal.show('modal-damages-history');
          },

          show_sold_history: function(item) {
            this.selectedItem = item;
            this.fetchHistory('sold');
            this.$bvModal.show('modal-sold-history');
          },

          fetchHistory: function(field) {
            if (!this.selectedItem) return;

            let splitted = this.selectedItem.locsub.split("|");
            let location_id = parseInt(splitted[0]);
            let sublocation_id = parseInt(splitted[1]);

            let data = {
                product_sku: this.selectedItem.product_sku,
                location_id: location_id,
                sublocation_id: sublocation_id,
                field: field
            };

            let path = "/api/inventory/get_inventory_history/";
            let that = this;
            let s = function(response) {
                console.log('History API response:', response.data);
                if (response.data.result) {
                    // Enhance the history data with location names
                    let enhancedHistory = response.data.result.map(item => {
                        // Fix for optional chaining - use traditional approach
                        let locationName = 'Unknown';
                        if (that.packet.locations) {
                            let location = that.packet.locations.find(function(loc) {
                                return loc.value === location_id;
                            });
                            locationName = location ? location.text : 'Unknown';
                        }

                        let sublocationKey = location_id + '|' + sublocation_id;
                        let sublocationName = that.packet.locsubsdict[sublocationKey] || 'Unknown';

                        return {
                            ...item,
                            location_name: locationName,
                            sublocation_name: sublocationName
                        };
                    });

                    if (field === 'received') {
                        that.receivedHistory = enhancedHistory;
                    } else if (field === 'missing') {
                        that.missingHistory = enhancedHistory;
                    } else if (field === 'damages') {
                        that.damagesHistory = enhancedHistory;
                    } else if (field === 'sold') {
                        that.soldHistory = enhancedHistory;
                    }
                } else {
                    that.$bvToast.toast(
                        response.data.error || "Error fetching history",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
            }

            let f = function(error) {
                console.error('History API error:', error);
                that.$bvToast.toast(
                    "Error fetching history data.",
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
            }
            Requestor.getSync(path, data, s, f);
          },
          
          saveReceivedHistory: function() {
            this.saveHistory('received', this.newReceivedQty);
          },

          saveMissingHistory: function() {
            this.saveHistory('missing', this.newMissingQty);
          },

          saveDamagesHistory: function() {
            this.saveHistory('damages', this.newDamagesQty);
          },

          saveSoldHistory: function() {
            this.saveHistory('sold', this.newSoldQty);
          },

          saveHistory: function(field, quantity) {
            if (!this.selectedItem || !quantity || quantity <= 0) {
                this.$vex.dialog.alert({
                    message: "Please enter a valid quantity"
                });
                return;
            }

            let splitted = this.selectedItem.locsub.split("|");
            let location_id = parseInt(splitted[0]);
            let sublocation_id = parseInt(splitted[1]);

            let data = {
                product_sku: this.selectedItem.product_sku,
                location_id: location_id,
                sublocation_id: sublocation_id,
                field: field,
                quantity: parseInt(quantity),
                username: this.packet.userDetails.username,
                source: 'Manual Entry' // You can modify this based on your needs
            };

            let path = "/api/inventory/add_inventory_history/";
            let that = this;
            let s = function(response) {
                if (response.data.error) {
                    that.$bvToast.toast(
                        response.data.error,
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                } else {
                    that.$bvToast.toast(
                        `ADDED ${field.toUpperCase()} HISTORY.`,
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                    that.newReceivedQty = 0;
                    that.newMissingQty = 0;
                    that.newDamagesQty = 0;
                    that.newSoldQty = 0;
                    that.fetchHistory(field);
                    that.get_inventory_for_location(); // Refresh main data
                }
            }

            let f = function(error) {
                that.$bvToast.toast(
                    `Error adding ${field} history.`,
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
            }
            Requestor.postAsyncP(path, data, this, s, f);
          },

          deleteHistoryItem: function(field, historyId) {
            let data = {
                history_id: historyId
            };

            let path = "/api/inventory/delete_inventory_history/";
            let that = this;
            let s = function(response) {
                if (response.data.error) {
                    that.$bvToast.toast(
                        response.data.error,
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                } else {
                    that.$bvToast.toast(
                        "DELETED HISTORY ITEM.",
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                    that.fetchHistory(field);
                    that.get_inventory_for_location(); // Refresh main data
                }
            }

            let f = function(error) {
                that.$bvToast.toast(
                    "Error deleting history item.",
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
            }
            Requestor.postAsyncP(path, data, this, s, f);
          },

        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            let that = this;
            if (this.packet.userDetails.properties.location_id){
                let location_id = this.packet.userDetails.properties.location_id;
                this.locations= this.packet.locations.filter(function(d){
                    return (d.value == location_id || d.is_main_warehouse == true)
                });
            }
            else {
                this.locations= this.packet.locations;
            }

            this.locations = this.locations.filter(function(d){return d.text != 'All'});
            this.locations = this.locations.sort(function(a,b){return a.is_main_warehouse - b.is_main_warehouse })
        }
    }
</script>

<style scoped>
/* Modal Table Styling */
/* Invoice link styling */
.invoice-link {
    color: #007bff;
    text-decoration: none;
    font-weight: 500;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.2s;
}

.invoice-link:hover {
    color: #0056b3;
    background-color: #f8f9fa;
    text-decoration: none;
}

/* Highlight reserved items */
.text-warning {
    font-weight: bold;
}

/* Make the reserved cell more prominent when there are reservations */
.clickable-cell.text-warning {
    background-color: #fff3cd;
    border-radius: 4px;
    padding: 2px 8px;
    display: inline-block;
}
.history-table-card {
    border: none;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.compact-table {
    font-size: 0.8rem;
}

.compact-table th {
    background-color: #f8f9fa;
    font-weight: 600;
    color: #2c3e50;
    border-bottom: 2px solid #dee2e6;
    padding: 8px 12px;
}

.compact-table td {
    padding: 6px 12px;
    vertical-align: middle;
    border-color: #e9ecef;
}

/* Table responsive wrapper */
.table-responsive {
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

/* Quantity badges */
.compact-table .badge {
    font-size: 0.75rem;
    padding: 4px 8px;
}

/* Action buttons */
.action-btn {
    padding: 2px 6px;
    border: none;
}

/* Timestamp and user cells */
.timestamp-cell, .user-cell {
    white-space: nowrap;
    font-size: 0.75rem;
    color: #6c757d;
}

/* Source badges */
.source-badge {
    font-size: 0.7rem;
    padding: 3px 6px;
}

/* Empty state */
.compact-table .table-empty {
    padding: 20px;
    text-align: center;
    color: #6c757d;
}
.clickable-cell {
    cursor: pointer;
    padding: 2px 5px;
    border-radius: 3px;
    transition: background-color 0.2s;
}

.clickable-cell:hover {
    background-color: #f8f9fa;
}

.ipt_tdhr {
    padding: 8px;
    border: 1px solid #dee2e6;
}

/* Add some spacing for the edit inputs */
.b-input {
    margin-right: 5px;
}

.b-badge {
    margin-right: 3px;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Inventory/InventoryByLocation.vue